/*
 * @Description: 订单信息编辑
 * @Author: 杨志航
 * @Date: 2026-07-07 17:25:33
 */

import React, { useState, useEffect } from 'react'
import api from '@/api'
import {
  Form,
  Input,
  message,
} from 'antd'
import BtnGroup from '@/components/BtnGroup'
import { allTrim, filterParams } from '@/utils'

const FormItem = Form.Item

const EditForm = (props) => {
  const { getFieldDecorator, validateFields, getFieldsValue, setFieldsValue } = props.form
  const { setVisible, editData, getList } = props
  const [saveLoading, setSaveLoading] = useState(false)

  useEffect(() => {
    const { adr_port_identify, adr_original_vendor_id, contractNo } = editData
    if (adr_port_identify) {
      setFieldsValue({
        portIdentify: adr_port_identify,
      })
    }
    if (adr_original_vendor_id) {
      setFieldsValue({
        originalVendorId: adr_original_vendor_id,
      })
    }
    if (contractNo) {
      setFieldsValue({
        contractNo,
      })
    }
  }, [])

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 18 },
    }
  }

  const formSubmit = (e) => {
    e.preventDefault()
    setFieldsValue(allTrim(getFieldsValue()))
    validateFields((err, vals) => {
      if (!err) {
        const { adr_id } = editData
        vals = filterParams(vals)
        vals = {
          orderId: adr_id,
          ...vals,
        }
        setSaveLoading(true)
        api.updateOrderPortAndVendor(vals).then(() => {
          setSaveLoading(false)
          setVisible(false)
          message.success('编辑成功')
          getList()
        }).catch(() => setSaveLoading(false))
      }
    })
  }

  return (
    <div>
      <Form onSubmit={formSubmit} {...formItemLayout}>
        <FormItem label="订单编号">
          {editData.adr_number || '--'}
        </FormItem>
        <FormItem label="厂商ID">
          {editData.adr_cid || '--'}
        </FormItem>
        <FormItem label="端口识别号">
          {getFieldDecorator('portIdentify', {
            rules: [{ required: true, message: '请输入端口识别号' }]
          })(
            <Input placeholder="请输入端口识别号" />
          )}
        </FormItem>
        <FormItem label="原始厂商ID">
          {getFieldDecorator('originalVendorId', {
            rules: [{ required: true, message: '请输入原始厂商ID' }]
          })(
            <Input placeholder="请输入原始厂商ID" />
          )}
        </FormItem>
        <FormItem label="合同编号">
          {getFieldDecorator('contractNo')(
            <Input placeholder="请输入合同编号" />
          )}
        </FormItem>
        <BtnGroup onCancel={() => setVisible(false)} loading={saveLoading} />
      </Form>
    </div>
  );
}

export default Form.create()(EditForm)
